<template>
    <div id="body">
        <div id="portfolio-feature-wrap">
            <div id="portfolio-feature">
                <div id="frame" class="frame frame-accolades">
                    <Header :mobile="platform.mobile" @sub-navigation-navigate="$emit('sub-navigation-navigate', $event)"/>
                    <div class="content-secondary">
                        <h1 class="no-margin-b">Accolades</h1>
                        <p class="accolades-collection-counts" v-html="collectionCounts"></p>

                        <!-- Navigation -->
                        <div id="accolade-navigation" class="flex m-hide">
                            <div class="accolade-tab" v-for="(accoladeCategory, a) in navigation.tabs" :key="a">
                                <span :class="['btn', TabState(accoladeCategory)]" @click="SelectAccoladeCategory(accoladeCategory)">{{ accoladeCategory }}</span>
                            </div>
                        </div>

                        <!-- Accolades -->
                        <div id="accolades">
                            <Collection
                                v-for="(accoladeCategory, a) of accolades"
                                :key="a"
                                :accolades="accoladeCategory"
                                :collectionName="a"
                                :show="ShowCollection(a)"
                                :mobile="platform.mobile"
                                @collection-counts="SetCollectionCounts($event)"
                                @last-viewed-top-position="ScrollToLastViewed($event)"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Template/Header.vue";
import Collection from "@/components/Accolades/Collection.vue";
import { viewModel } from "@/models";
import { MASTER } from "@/assets/JS/Master.js";
import {
    ItemReveal,
    ASSETS
} from "@/assets/JS/Assets.js";
import { READ } from "@/data/Read.js";
import DataAPI from "@/data/API.js";
import store from "@/store";
import $ from "jquery";

export default {
    name: "AccoladesView",
    props: { ...viewModel.props },
    components: {
        Header,
        Collection
    },
    data: () => ({
        ...viewModel.data,
        itemReveal: class {},
        collectionCounts: "",
        collectionsLoaded: 0,
        navigation: {
            tabs: [],
            currentAccoladeCategory: "Features"
        },
        accoladeHeading: "",
        accolades: {}
    }),
    methods: {
        SetCollectionCounts: function(counts) {
            this.platform.mobile = MASTER.Platform._mobile;
            this.collectionsLoaded++;
            const totalAccolades = Object.keys(this.accolades).length;
            let delimiter, connector;
            delimiter = "";
            connector = "";
            if (!this.platform.mobile) {
                delimiter = this.collectionsLoaded < totalAccolades - 1 ? ", " : "";
                connector = this.collectionsLoaded === totalAccolades ? " and " : "";
            } else {
                delimiter = this.collectionsLoaded < totalAccolades - 1 ? "<br/>" : "";
                connector = this.collectionsLoaded === totalAccolades ? "<br/>" : "";
            }
            this.collectionCounts += `${connector}<b>${counts.counts}</b> <i>${counts.collection}</i>${delimiter}`;
        },
        Accolades: function(category) {
            const accolades = this.accolades.filter(a => a.name === category)[0];
            return accolades.accolades;
        },
        TabState: function(accoladeCategory) {
            return accoladeCategory === this.navigation.currentAccoladeCategory ? "tab-active" : "";
        },
        SelectAccoladeCategory: function(accoladeCategory) {
            this.navigation.currentAccoladeCategory = accoladeCategory;
            const accoladeNavigation = ASSETS.GetStorage("PortfolioAccoladeNavigation");
            if (accoladeNavigation) {
                accoladeNavigation.category = accoladeCategory;
                ASSETS.SetStorage("PortfolioAccoladeNavigation", {
                    category: accoladeNavigation.category,
                    accoladeID: accoladeNavigation.accoladeID
                });
            }
        },
        ShowCollection: function(accoladeCategory) {
            return !this.platform.mobile
                ? this.navigation.currentAccoladeCategory === ASSETS.CustomAccoladeName(accoladeCategory)
                : true;
        },
        ScrollToLastViewed: function(topPosition) {
            $("html").scrollTop(topPosition);
        }
    },
    mounted: async function() {
        this.$emit("start-loader", "#app");

        // Get accolades
        const accoladesStorage = ASSETS.GetStorage("PortfolioAccolades");
        let accolades = { Features: [] };
        if (!accoladesStorage) {
            accolades = await READ.Accolades(this, DataAPI);
        } else {
            accolades = accoladesStorage.accolades;
        }
        ASSETS.SetStorage("PortfolioAccolades", { accolades });
        this.accolades = accolades;

        this.itemReveal = new ItemReveal(this.accolades.Features, 5, 5);

        // Setup tabular navigation
        this.navigation.tabs = [];
        for (const accoladeCategory in this.accolades) {
            const accoladeName = ASSETS.CustomAccoladeName(accoladeCategory);
            this.navigation.tabs.push(accoladeName);
        }

        // Set selected category state
        const accoladeNavigation = ASSETS.GetStorage("PortfolioAccoladeNavigation");
        let category, accoladeID;
        category = "";
        accoladeID = -1;
        if (!accoladeNavigation) {
            category = this.navigation.currentAccoladeCategory;
            accoladeID = -1;
        } else {
            category = accoladeNavigation.category;
            accoladeID = accoladeNavigation.accoladeID;
        }
        this.SelectAccoladeCategory(category);
        ASSETS.SetStorage("PortfolioAccoladeNavigation", {
            category,
            accoladeID
        });

        this.$emit("stop-loader");
    },
    emits: [ ...viewModel.emits ]
};
</script>